<!--
 * @description: 服务回访
 * @param: 
 * @return: 
 老版逻辑对照
-->
<template>
  <div class="container-serve">
    <div class="condition-list-container">
      <div class="conditon-bontainer">
        <text-field v-model:value="condition.BrandId" labelText="品牌名称:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.compid" @change="handleCompid" />
        <text-field v-model:value="condition.ProductId" labelText="产品类别:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.ProductId" @change="handleProductId" />
        <text-field v-model:value="condition.ModelNoId" labelText="产品型号:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.ModelNoId" />

        <text-field v-model:value="condition.sn" labelText="SN:" class="condition-container-input">
        </text-field>
      </div>

      <div class="btn-container">
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </div>
    </div>
    <div class="main-container">
      <div class="header-container">
        <div class="title">备机列表</div>
        <div class="btnHandle" @click="handleAdd">
          添加
        </div>
      </div>
      <div class="tabel-container">
        <el-table ref="tableInstance" :data="tableData" style="width: 100%" @row-dblclick="rowDbClick"
          @cell-contextmenu="contextmenu" border stripe highlight-current-row height="421"
          header-row-class-name="header-row-class-name" header-cell-class-name="header-row-class-name">
          <el-table-column :show-overflow-tooltip="true" prop="BrandName" label="品牌" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ProCateName" label="产品" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="ModelNoName" label="型号" width="100" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="SerialNoName" label="SN" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="StateName" label="状态" width="width" sortable
            :sort-orders="['ascending', 'descending']" resizable align="center">
            <template #default="{ row }">
              <span>{{ row.StateName }}</span>
              <el-select v-model="row.StateNameSelect" @change="(v) => { statusChange(v, row) }" placeholder="请选择"
                size="small" v-if="false">
                <el-option v-for="item in optionsStatus" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="AttachName" label="附件" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="CompName" label="返回地" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="PreMachDesc" label="备注" width="width" resizable
            align="center">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="FileName" label="删除" width="width" resizable
            align="center">
            <template #="{ row }">
              <div class="style-aaa" @click="handleDelete(row)">删除</div>
              <!-- <el-button @click="handleDelete(row)">
                <i class="el-icon-delete"></i>
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation-container">
        <el-pagination background :page-size="pageSize" :total="rowsCount" :pager-count="pagerCount" :prev-text="'上一页'"
          :next-text="'下一页'" @current-change="pageChange" @size-change="sizeChange"
          layout="sizes,total, prev, pager, next, jumper,slot" style="margin-top: 20px;">
          <template #default>
            <el-button size="mini" @click="refresh">刷新</el-button>
          </template>
        </el-pagination>
      </div>
    </div>

    <el-dialog v-model="dialogFormVisible" title="备机详情" @close="handleDialogClose" width="80%">
      <div class="condition-panel">
        <div class="float-style">
          <el-button type="primary" class="btn" @click="handleSearchDb">搜索</el-button>
        </div>
        <div class="form-dialog-condition-one">
          <text-field v-model:value="dialogFormDataCondition.cmp" labelText="客户:" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataCondition.link" labelText="联系人:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataCondition.trs" type="date" labelText="寄送起始日期:" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataCondition.tre" type="date" labelText="寄送结束日期:" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataCondition.trn" labelText="寄送单号:" class="condition-container-input">
          </text-field>
          <text-field v-model:value="dialogFormDataCondition.res" type="date" labelText="归还起始日期:" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataCondition.ree" type="date" labelText="归还结束日期:" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataCondition.ren" labelText="归还单号:" class="condition-container-input">
          </text-field>
        </div>
      </div>
      <div class="data-show-panel">
        <div class="serve-list">备机详细信息</div>
        <div class="show-condition-list">
          <text-field v-model:value="dialogFormDataShow.BrandName" labelText="品牌名称:" :readOnly="true" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataShow.ProCateName" labelText="产品类型:" :readOnly="true"
            :clearable="true" class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataShow.ModelNoName" labelText="产品型号:" :readOnly="true"
            :clearable="true" class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataShow.SerialNoName" labelText="SN:" :readOnly="true" :clearable="true"
            class="condition-container-input"></text-field>
          <text-field v-model:value="dialogFormDataShow.PreMachDesc" labelText="备注:" :clearable="true"
            class="condition-container-input"></text-field>
        </div>
        <div class="show-condition-list">
          <text-field v-model:value="dialogFormDataShow.IsRuturn" labelText="是否归还:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.isRuturn" />
        </div>
        <el-table :data="dialogFormDataShow.list" style="width: 100%" height="300">
          <el-table-column prop="CompName" label="客户" width="width" align="center">
          </el-table-column>
          <el-table-column prop="LinkMan" label="联系人" width="width" align="center">
          </el-table-column>
          <el-table-column prop="TelNo" label="联系电话" width="width" align="center">
          </el-table-column>
          <el-table-column prop="Phone" label="联系手机" width="width" align="center">
          </el-table-column>
          <el-table-column prop="TranDate" label="寄送日期" width="width" align="center">
          </el-table-column>
          <el-table-column prop="TransferNo" label="寄送单号" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReCompName" label="返回地" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReturnDate" label="归还日期" width="width" align="center">
          </el-table-column>
          <el-table-column prop="ReTransferNo" label="归还单号" width="width" align="center">
          </el-table-column>
        </el-table>
        <el-pagination background :page-size="pageSizeDia" :total="rowsCountDia" :pager-count="pagerCount"
          :prev-text="'上一页'" :next-text="'下一页'" @current-change="pageChangeDia" @size-change="sizeChangeDia"
          layout="sizes,total, prev, pager, next, jumper,slot" style="margin-top: 20px;">
          <template #default>
            <el-button size="mini" @click="refreshDia">刷新</el-button>
          </template>
        </el-pagination>
      </div>
      <template #footer>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>

    <!-- 添加-添加包含附件 -->
    <el-dialog v-model="sendBackDialogAddFJ" title="备机设备编辑信息" width="40%" top="15%" 
    @close="sendBackDialogAddFJClose">
      <div class="add-fj-container">
        <div class="add-row">
          <text-field v-model:value="conditionAdd.BrandId" labelText="品牌名称:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.compid" @change="handleCompid" />
          <text-field v-model:value="conditionAdd.ProductId" labelText="产品类别:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.ProductId" @change="handleProductId" />
        </div>
        <div class="add-row">
          <text-field v-model:value="conditionAdd.ModelNo_Id" labelText="产品型号:" :clearable="true" type="select"
            class="condition-container-input" :selectChildData="options.ModelNoId" />
          <text-field v-model:value="conditionAdd.SerialNoName" labelText="SN:" :clearable="true"
            class="condition-container-input" />
        </div>
        <div class="add-row">
          <div class="text-container">
            <div class="text">附件:</div>
            <div v-if="fjData.length > 0">
              <el-checkbox-group v-model="conditionAdd.AttachName">
                <el-checkbox v-for="(item, index) in fjData" :key="`${item.Name}${index}`" :label="item.Name"
                  :model-value="item.id" />
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="add-row">
          <text-field v-model:value="conditionAdd.Company_Id" labelText="返回地:"
           :clearable="true" type="select"
            :selectRemoteSearchData="selectOuguNameShooin" class="condition-container-input" />
        </div>
        <div class="add-row">
          <div class="text-container">
            <div class="text">备注:</div>
            <div>
              <el-input v-model="conditionAdd.PreMachDesc" :rows="4" type="textarea" resize="none" />
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <el-button type="primary" @click="sendBackSaveAdd">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import { defineComponent, reactive, toRefs, watch, ref, onMounted } from "vue";
import tableApi from "@/api/tabel.js";
import { errMsg, successMsg } from "@/notify/index.js";

import { ElMessageBox } from 'element-plus'
export default defineComponent({
  name: "messageCenter",
  components: {
    textField,
    tabelPanel,
    popDialog,
  },
  props: {},
  emits: [],

  setup(props, { emit }) {
    const data = reactive({
      sendBackDialogAddFJ: false,
      conditionAdd: { AttachName: [] },
      fjData: [],
      pageSizeDia: 10,
      rowsCountDia: 100,
      currentIndexDia: 1,

      tabelSelectionList: [],
      tableInstance: null,
      dialogFormVisible: false, //dialog
      pagerCount: 7, //总页按钮数，超过当前数会折叠
      rowsCount: 100, //总条数
      pageSize: 20, //每页条数
      currentIndex: 1, //当前页数
      condition: {},
      dialogFormDataCondition: {}, //双击查询条件
      dialogFormDataShow: { list: [] }, //双击展示信息
      options: {
        compid: [],
        ProductId: [],
        ModelNoId: [],
        isRuturn: [
          { value: 1, label: '是' },
          { value: 0, label: '否' },
        ]
      },
      optionsStatus: [
        {
          label: '备用',
          value: '备用',
        },
        {
          label: '借出',
          value: '借出',
        },
        {
          label: '归还厂家',
          value: '归还厂家',
        },
      ],
      tableData: [],
      dialogFormData: {},
    });
    onMounted(() => {
      methods.getSource();
      methods.getPinP();
    });
    let methods = {
      // 获取品牌信息
      async getPinP() {
        const res = await tableApi.BrandSelect();
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.options.compid = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      async handleCompid(v) {
        console.log(v);
        data.condition.ModelNoId = "";
        data.condition.ProductId = "";
        if (!v) return;

        const res = await tableApi.ProductSelect({ Bid: v });
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.options.ProductId = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      async handleProductId(v) {
        data.condition.ModelNoId = "";
        if (!v) return;
        tableApi.AttachSelect(v).then((res) => {
          console.log(res, "附件");
          data.fjData = res.data.list;
          // debugger;
        });
        const res = await tableApi.modelSelect({ ProductCategoryId: v });
        if (res.code == 0) {
          const {
            data: { list },
          } = res;
          data.options.ModelNoId = list.map((item) => ({
            label: item.Name,
            value: item.id,
          }));
        }
      },
      async selectOuguNameShooin() {
        let source = await tableApi.CompanyInfoShooin();
        this.CompanyIdData = source.data.list;
        if (source.code == 0) {
          let data = source.data.list.map(({ Company_Id, CompName }) => {
            return {
              label: CompName,
              value: Company_Id,
            };
          });

          let total = 0;
          return {
            total,
            data,
          };
        } else {
          errMsg(this, source.message);
        }
      },
      // 客户数据
      async remoteData() {
        let source = await tableApi.CompanyInfo();
        if (source.code == 0) {
          let data = source.data.list.map(({ Company_Id, CompName }) => {
            return {
              label: CompName,
              value: Company_Id,
            };
          });
          let total = 0;
          return {
            total,
            data,
          };
        } else {
          errMsg(this, source.message);
        }
      },
      //   shooin公司数据
      async selectOuguNameShooin() {
        let source = await tableApi.CompanyInfoShooin();
        this.CompanyIdData = source.data.list;
        if (source.code == 0) {
          let data = source.data.list.map(({ Company_Id, CompName }) => {
            return {
              label: CompName,
              value: Company_Id,
            };
          });

          let total = 0;
          return {
            total,
            data,
          };
        } else {
          errMsg(this, source.message);
        }
      },
      getSource(
        obj = {
          BrandId: null,
          ProductId: null,
          ModelNoId: null,
          sn: null,
          page: data.currentIndex,
          limit: data.pageSize,
        }
      ) {
        tableApi.PreMachineListSearch(obj).then((res) => {
          console.log(res, "服务回访res");
          res.data.list.forEach(i => {
            i.changeStatus = false
            i.StateNameSelect = ""
          })
          data.tableData = res.data.list;
          data.rowsCount = res.data.count;
        });
      },

      handleSearch() {
        const params = {
          page: data.currentIndex,
          limit: data.pageSize,
          ...data.condition,
        };
        methods.getSource(params);
      },
      pageChange(pageIndex, limit) {
        data.currentIndex = pageIndex;
        methods.handleSearch();
        console.log("页数改变", pageIndex, limit);
      },
      pageChangeDia(pageIndex, limit) {
        data.currentIndexDia = pageIndex;
        methods.handleSearchDb();
      },
      sizeChange(v) {
        data.pageSize = v;
        methods.handleSearch();
        console.log("每页条数改变", v);
      },
      sizeChangeDia(v) {
        data.pageSizeDia = v;
        methods.handleSearchDb();
      },
      refresh() {
        console.log("刷新");
        methods.handleSearch();
      },
      refreshDia() {
        methods.handleSearchDb();
      },
      rowDbClick(v, c, event) {
        // console.log(v, "dbclick",c,event);
        Object.assign(data.dialogFormDataShow, v);
        data.dialogFormVisible = true;
        methods.handleSearchDb();
      },
      contextmenu(r, co, cl, event) {
        //阻止默认事件
        event.preventDefault()
        console.log(r, co, cl, event, '单元格')
        if (co.label != "状态") {
          return
        }
        data.tableData.forEach(i => {
          i.changeStatus = false
        })
        r.changeStatus = true
      },
      // 这里需要修改
      statusChange(v, row) {
        console.log(v, row, 'selec')
        if (v == row.StateName) {
          row.changeStatus = false
          return
        }
        console.log(v, "发送请求修改---刷新页面")
      },
      handleSearchDb() {
        //  pageSizeDia:10,
        // rowsCountDia:100,
        // currentIndexDia:1,
        const params = {
          ...data.dialogFormDataCondition,
          sn: data.dialogFormDataShow.SerialNoName,
          page: data.currentIndexDia,
          limit: data.pageSizeDia,
        };
        tableApi.PreMachineListDetailSearch(params).then((res) => {
          const arr = res.data.list;
          data.dialogFormDataShow.list = arr;
          data.rowsCountDia = res.data.count;
        });
      },
      handleSave() {

        const params = {
          sn: data.dialogFormDataShow.SerialNoName,
          desc: data.dialogFormDataShow.PreMachDesc,
          IsRuturn: data.dialogFormDataShow.IsRuturn
        };
        tableApi.PreMachineEditeCommit(params).then((res) => {
          if (res.code == 0) {
            data.dialogFormVisible = false
            data.dialogFormDataShow = { list: [] }
            successMsg("保存成功");
          } else {
            errMsg(res.message)
          }

        });
      },
      handleDialogClose() {
        data.dialogFormDataCondition = {
          trs: '',
          tre: '',
          res: '',
          ree: ''
        };
      },
      handleAdd() {
        data.sendBackDialogAddFJ = true;

      },
      sendBackDialogAddFJClose() {
        data.conditionAdd = { AttachName: [] }
        data.fjData=[]
        console.log("关闭", data.conditionAdd)
      },
      sendBackSaveAdd() {
        const keys = Object.keys(data.conditionAdd);
        const res = keys.find((i) => {
          if (data.conditionAdd[i] === undefined) {
            return i;
          }
        });
        if (res || !data.conditionAdd.PreMachDesc) {
          errMsg("请输入");
          return;
        }
        const AttachName = data.conditionAdd.AttachName;
        const Attach = AttachName.map((i) => {
          return data.fjData.find((item) => {
            if (item.Name == i) {
              return item;
            }
          }).id;
        }).join(',')
        const params = {
          list: [{
            ...data.conditionAdd,
            Attach,
            AttachName: AttachName.join(","),
          }]
        };
        tableApi.PreMachineMangeFinishById(params).then((res) => {
          console.log(res, "添加保存");
          data.sendBackDialogAddFJ = false;
          methods.refresh()
          data.conditionAdd = { AttachName: [] }
        });
      },
      handleDelete(row) {
        ElMessageBox.confirm("确定删除吗？", '提示', {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          tableApi.DelPreMachineListById({ Id: row.Id }).then(res => { successMsg("删除成功") })
          methods.refresh()
        }).catch(() => { })

      },
    };

    return {
      ...toRefs(data),
      ...methods,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
.container-serve {
  width: 100%;
  height: 100%;
  font-family: 'hanSan' !important;

  .condition-list-container {
    width: 100%;
    height: auto;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    border-radius: 5px;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    padding: 0.15625rem 0.125rem;
    overflow: hidden;
    box-sizing: border-box;

    .conditon-bontainer {
      width: 100%;
      display: flex;

      .condition-container-input {
        width: 270px;
      }
    }

    .btn-container {
      :deep(.el-button, el-button--primary) {
        border-radius: 10px;
      }
    }
  }

  .main-container {
    width: 100%;
    height: auto;

    .header-container {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      padding: 20px 10px;

      .title {
        color: rgb(4, 53, 250);
      }

      .btnHandle {
        cursor: pointer;
        width: 50px;
        height: 30px;
        border-radius: 10px;
        line-height: 30px;
        text-align: center;
        background-color: rgb(4, 53, 250);
        color: white;
      }
    }

    .tabel-container {
      :deep(.header-row-class-name) {
        background-color: rgb(100, 134, 232) !important;
        color: white !important;
      }

      :deep(.el-table--enable-row-transition) {
        border: rgb(100, 134, 232) solid 1px !important;
        box-sizing: border-box;
        border-radius: 2px;
      }
    }
  }
}

.condition-panel {
  .form-dialog-condition-one {
    display: flex;
    flex-wrap: wrap;
    height: 130px;
    margin: 10px 0;
    width: 100%;
  }

  .float-style {
    .btn {
      float: right;
    }
  }

  .form-dialog-condition-two {
    display: flex;
    width: 100%;
    margin: 10px 0;
  }

  .form-dialog-condition-three {
    display: flex;
    margin: 10px 0;
    flex-wrap: wrap;
    // border:1px solid red;
    width: 80%;

    .radio-panel-list {
      width: 50%;
      display: flex;
      margin: 18px 0;

      .label {
        margin-right: 20px;
        font-size: 16px;
        font-weight: bold;
        align-items: center;
      }
    }
  }

  .form-dialog-condition-four {
    display: flex;
    margin: 10px 0;

    .label {
      font-size: 16px;
      font-weight: bold;
      margin-right: 20px;
    }
  }
}

.data-show-panel {
  .serve-list {
    background-color: rgb(68, 102, 237);
    margin: 10px 0;
    color: white;
  }

  .show-condition-list {
    display: flex;
    height: 50px;
  }
}

.footer-container {
  display: flex;
  justify-content: center;

  .cancel-style {
    margin-right: 30px;
  }
}

.text-area-width {
  width: 400px;
}

.add-row {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 20px;
  justify-content: space-between;

  .text-container {
    display: flex;

    .text {
      font-size: 16px;
      font-weight: 800;
      width: 60px;
      text-align: center;
      margin-right: 8px;
    }
  }

  :deep(.el-textarea__inner) {
    width: 412px !important;
  }
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
